module.exports = __webpack_public_path__ + "static/img/NP@2x.526ea987.jpg";